import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter } from 'react-icons/fa';
import logo from '../assets/Navbar/New logo.png'; // Adjust the path to your logo file

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="bg-[#F3ECDE] text-gray-700 py-6 sm:py-8 md:py-12">
            <div className="container mx-auto px-4 sm:px-6 md:px-8">
                {/* Centered Logo */}
                <div className="flex justify-center mb-4 sm:mb-6">
                    <img src={logo} alt={t('footerSection.logoAlt')} className="h-24 sm:h-32 w-auto" />
                </div>

                {/* Main Footer Content */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8 text-center md:text-left">
                    {/* Sun Flower Beach Resort Links */}
                    <div>
                        <h5 className="text-base sm:text-lg md:text-xl font-semibold text-[#12392B] mb-3 sm:mb-4">
                            {t('footerSection.resortTitle')}
                        </h5>
                        <ul className="space-y-2">
                            <li>
                                <NavLink to="/" className="text-gray-600 hover:text-[#E6A71A] transition-colors text-sm sm:text-base">
                                    {t('footerSection.links.home')}
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/about-us" className="text-gray-600 hover:text-[#E6A71A] transition-colors text-sm sm:text-base">
                                    {t('footerSection.links.aboutUs')}
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/villa" className="text-gray-600 hover:text-[#E6A71A] transition-colors text-sm sm:text-base">
                                    {t('footerSection.links.resort')}
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/ayurveda-spa" className="text-gray-600 hover:text-[#E6A71A] transition-colors text-sm sm:text-base">
                                    {t('footerSection.links.ayurvedaWellness')}
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/packages" className="text-gray-600 hover:text-[#E6A71A] transition-colors text-sm sm:text-base">
                                    {t('footerSection.links.packages')}
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/contact-us" className="text-gray-600 hover:text-[#E6A71A] transition-colors text-sm sm:text-base">
                                    {t('footerSection.links.contactUs')}
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    {/* Get in Touch */}
                    <div>
                        <h5 className="text-base sm:text-lg md:text-xl font-semibold text-[#12392B] mb-3 sm:mb-4">
                            {t('footerSection.getInTouchTitle')}
                        </h5>
                        <ul className="space-y-2">
                            <li className="flex items-center justify-center md:justify-start">
                                <svg className="w-4 sm:w-5 h-4 sm:h-5 mr-2 text-[#12392B]" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M10 2a6 6 0 00-6 6c0 2.5 1.5 4.5 3.5 5.5.5.2 1 .3 1.5.3s1-.1 1.5-.3c2-1 3.5-3 3.5-5.5a6 6 0 00-6-6zm0 9a3 3 0 110-6 3 3 0 010 6z" />
                                </svg>
                                <span className="text-sm sm:text-base text-gray-600">
                                    {t('footerSection.address')}
                                </span>
                            </li>
                            <li className="flex items-center justify-center md:justify-start">
                                <svg className="w-4 sm:w-5 h-4 sm:h-5 mr-2 text-[#12392B]" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3 3h10v1H5V8zm0 3h10v1H5v-1z" />
                                </svg>
                                <a
                                    href="mailto:sunflower.beruwala@gmail.com"
                                    className="text-sm sm:text-base text-gray-600 hover:text-[#E6A71A] transition-colors"
                                >
                                    {t('footerSection.email')}
                                </a>
                            </li>
                            <li className="flex items-center justify-center md:justify-start">
                                <svg className="w-4 sm:w-5 h-4 sm:h-5 mr-2 text-[#12392B]" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M2 3a1 1 0 011-1h2.5l1.5 4.5L5 9a11 11 0 007 3l2.5-2 4.5 1.5V17a1 1 0 01-1 1H3a1 1 0 01-1-1V3z" />
                                </svg>
                                <a
                                    href="tel:+94775340670"
                                    className="text-sm sm:text-base text-gray-600 hover:text-[#E6A71A] transition-colors"
                                >
                                    {t('footerSection.phone')}
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Stay Connected */}
                    <div>
                        <h5 className="text-base sm:text-lg md:text-xl font-semibold text-[#12392B] mb-3 sm:mb-4">
                            {t('footerSection.stayConnectedTitle')}
                        </h5>
                        <div className="flex justify-center mb-4">
                            <div className="relative w-full max-w-[90%] sm:max-w-xs">
                                <input
                                    type="email"
                                    className="w-full p-2 sm:p-3 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-gray-500 text-sm sm:text-base"
                                    placeholder={t('footerSection.emailPlaceholder')}
                                    aria-label={t('footerSection.emailPlaceholder')}
                                />
                                <button className="absolute right-0 top-0 h-full px-3 sm:px-4 bg-[#12392B] text-white rounded-r-md hover:bg-[#E6A71A] transition-colors">
                                    <svg className="w-4 sm:w-5 h-4 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 010-2h7.586l-2.293-2.293a1 1 0 010-1.414z" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="flex justify-center gap-3 sm:gap-4">
                            <a
                                href="https://www.facebook.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#12392B] hover:text-[#E6A71A] transition-colors"
                                aria-label={t('footerSection.socialMedia.facebook')}
                            >
                                <FaFacebookF size={16} sm={20} />
                            </a>
                            <a
                                href="https://www.instagram.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#12392B] hover:text-[#E6A71A] transition-colors"
                                aria-label={t('footerSection.socialMedia.instagram')}
                            >
                                <FaInstagram size={16} sm={20} />
                            </a>
                            <a
                                href="https://www.youtube.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#12392B] hover:text-[#E6A71A] transition-colors"
                                aria-label={t('footerSection.socialMedia.youtube')}
                            >
                                <FaYoutube size={16} sm={20} />
                            </a>
                            <a
                                href="https://www.twitter.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#12392B] hover:text-[#E6A71A] transition-colors"
                                aria-label={t('footerSection.socialMedia.twitter')}
                            >
                                <FaTwitter size={16} sm={20} />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Divider */}
                <hr className="my-4 sm:my-6 md:my-8 border-[#12392B]" />

                {/* Footer Bottom */}
                <div className="text-center">
                    <p className="text-gray-800 text-xs sm:text-sm md:text-base">
                        {t('footerSection.copyright', { year: new Date().getFullYear() })}
                    </p>
                    <p className="text-gray-600 text-[10px] sm:text-xs mt-2">
                        {t('footerSection.developedBy.text')}{' '}
                        <a
                            href="tel:+94764608225"
                            className="text-gray-600 hover:underline"
                        >
                            {t('footerSection.developedBy.phone')}
                        </a>.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;